import { useMutation } from "urql";

import { UpdateCreditApprovalDocument } from "../../../graphql/generated.ts";

export const useUpdateCreditApproval = () =>
  useMutation(UpdateCreditApprovalDocument);
